
















import { Vue, Component } from "vue-property-decorator";
import { lockModule } from "@/store/lock";
import LockListItem from "@/components/LockListItem.vue";
import SearchInput from "@/components/common/SearchInput.vue";

@Component({
  components: { LockListItem, SearchInput }
})
export default class Locks extends Vue {
  searchInput = "";

  get searchString(): string {
    return this.searchInput.toLowerCase();
  }

  get locks() {
    return lockModule.locks.filter(lock =>
      lock.LockingObject?.toLowerCase().includes(
        this.searchString.toLowerCase()
      )
    );
  }

  mounted() {
    this.fetchLocks();
  }

  fetchLocks() {
    lockModule.fetchLocks();
  }
}
